import {RouterModule, Routes} from '@angular/router';
import {isDevMode, NgModule} from "@angular/core";

import {BokComponent} from './layout/bok/bok.component';
import {NotFoundComponent} from './layout/notfound/not-found.component';
import {PanelComponent} from './layout/panel/panel.component';

import {AuthGuard} from "@shared/guards/auth-guard.service";
import {HandoverComponent} from "@handover/routes/main-route/components/handover/handover.component";

const appRoutesModule: Routes = [
  {
    path: '', redirectTo: 'authentication', pathMatch: 'full'
  },
  {
    path: 'login', redirectTo: 'authentication'
  },
  {
    path: 'share', redirectTo: 'authentication/share'
  },
  {
    path: 'handover', redirectTo: 'authentication/handover'
  },
  {
    path: 'password-reset-confirm',
    redirectTo: 'authentication/set-new-password',
  },
  {
    path: 'authentication',
    loadChildren: () => import('@authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'bok', component: BokComponent
  },
  {
    path: 'panel/:subsite',
    component: PanelComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'handover-view/:token',
    component: HandoverComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '**', component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutesModule)],
  exports: [RouterModule]
})
export class AppRoutesModule {
  constructor() {
    if (isDevMode())
      console.log('AppRoutesModule');
  }
}
